import script from "./AddFamilyMember.vue?vue&type=script&setup=true&lang=js"
export * from "./AddFamilyMember.vue?vue&type=script&setup=true&lang=js"

import "./AddFamilyMember.vue?vue&type=style&index=0&id=7a29a5d9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a29a5d9"]])

export default __exports__